import sensorGroup from '@innovyze/stylovyze/lib/apis/sensorGroup.api';
export const getSensorGroupsService = (params) => sensorGroup.get('/sensor-groups', { params });
